import i18n from '@/utils/i18n';
import { getHotelFloor } from '@/api/realTime'
import { getHardwareRoomList } from '@/api/hardware'

const state = {
  traditionalLockRoomList: [],
  traditionalLockRoomListLoaded: false,
  floorList: [],
  floorListLoaded: false
}

const actions = {
  async fetchTraditionalLockRoomList({ state, commit }, force = false) {
    if (force || !state.traditionalLockRoomListLoaded) {
      const res = await getHardwareRoomList({ hardwareTypeCode: 'traditionalLock', pageSize: 1000, pageNum: 1 })
      commit('setTraditionalLockRoomList', res.data.map(i => ({ roomId: i.roomId, roomName: i.roomName, lockId: i.lockId })))
    }
    return state.traditionalLockRoomList
  },
  async fetchFloorList({ state, commit }, force = false) {
    if (force || !state.floorListLoaded) {
      const res = await getHotelFloor({})
      commit('setFloorList', res.data)
    }
    return state.roomList
  }
}

const mutations = {
  setTraditionalLockRoomList(state, list) {
    state.traditionalLockRoomList = list
    state.traditionalLockRoomListLoaded = true
  },
  setFloorList(state, list) {
    state.floorList = list
    state.floorListLoaded = true
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
